import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { DateTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { BenutzerBenutzerrechtDialogComponent } from './benutzer-benutzerrecht-dialog/benutzer-benutzerrecht-dialog.component';

import { BenutzerBenutzerrecht } from './BenutzerBenutzerrecht';

@Component({
    selector: 'kiene-benutzer-benutzerrechte',
    templateUrl: './benutzer-benutzerrechte.component.html',
    styleUrls: ['./benutzer-benutzerrechte.component.scss'],
})
export class BenutzerBenutzerrechteComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private messageService: MessageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private kieneTableService: KieneTableService,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.nameOfIdField = 'bbr_id';
        this.tableDescriptor.headline = 'Sonderrechte';
        this.tableDescriptor.uniqueIdentifier = 'benutzer_benutzerrechte';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'benutzer_benutzerrechte/';
        this.tableDescriptor.route = '/administration/benutzer_benutzerrechte/';
        this.tableDescriptor.searchPlaceholder = 'Sonderrechte durchsuchen';
        this.tableDescriptor.addVoid = this.openBBRDialog.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('benutzer_id', 'Benutzer ID'));
        this.tableDescriptor.columns.push(new TableColumn('benutzer', 'Benutzer'));
        this.tableDescriptor.columns.push(new TableColumn('benutzerrecht_id', 'Benutzerrecht ID'));
        this.tableDescriptor.columns.push(new TableColumn('benutzerrecht', 'Benutzerrecht'));
        this.tableDescriptor.columns.push(new DateTableColumn('editiert', 'Bearbeitet am:', 'dd.MM.yyyy'));
        this.tableDescriptor.columns.push(new TableColumn('editor', 'Bearbeitet von:'));
        this.tableDescriptor.columns.push(new DateTableColumn('erstellt', 'Erstellt am:', 'dd.MM.yyyy'));
        this.tableDescriptor.columns.push(new TableColumn('ersteller', 'Erstellt von:'));
        this.tableDescriptor.initialSortColumn = 'benutzerrecht_id';

        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.permissionView = 20;
        this.tableDescriptor.permissionCreate = 21;

        this.tableDescriptor.options.push(new TableOption(this.deleteBBR.bind(this), 'Löschen', 'delete', 23));
    }

    private openBBRDialog(): void {
        this.dialog
            .open(BenutzerBenutzerrechtDialogComponent, { width: '600px' })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.ok && result?.confirmed) {
                        this.kieneTableService.reload('benutzer_benutzerrechte');
                    }
                },
            });
    }

    private deleteBBR(bb: BenutzerBenutzerrecht): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Sonderrecht löschen';
        input.text = 'Möchten Sie das Sonderrecht wirklich löschen?';
        input.okButton = 'Löschen';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.ok && result?.confirmed) {
                        this.api.deleteEntity(this.apiBaseUrl + 'benutzer_benutzerrechte/delete.php', bb).subscribe({
                            next: () => {
                                this.kieneTableService.reload('benutzer_benutzerrechte delete');
                            },
                            error: err => {
                                this.messageService.errorMessage('Fehler beim Löschen des Sonderrechts.', err);
                            },
                        });
                    }
                },
            });
    }
}
